/**
 * Fix cbox empty buttons
 * 
 * This is a direct edit that was made to main.js.
 * Preserved here to maintain functionality.
 */

(function (Drupal, $) {

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.addText.attach}}
   */

  Drupal.behaviors.addText = {
    attach: function (context, settings){
      var thetimerinterval = setInterval(function() {
        if($.colorbox) {
          $('#cboxPrevious')[0].innerHTML='Prev';
          $('#cboxNext')[0].innerHTML='Next';
          $('#cboxSlideshow')[0].innerHTML='SlideShow';
           clearInterval(thetimerinterval);
        }
      }, 1000);
    }
  }
})(Drupal, jQuery);

